import { IPublishOptions } from './publishOption';
import { EServiceType } from './serviceType';

export interface IPublishTermsService {
  /** Более удобное строковое представление */
  id: string;
  /** Дополнительное описание услуги, показывающее чем оно лучше базового размещения */
  superiorOption: string | null;
  /** Название тарифа */
  name: string;
  /** Необходима идентификация пользователя */
  identificationRequired: boolean;
  /** Причина недоступности тарифа */
  unavailableReasonType: EUnavailableReason | null;
  /** Параметры публикации */
  publishOptions: IPublishOptions;
  /** Является дополнительным */
  isAdditional: boolean;
  /** Услуга обязательна к применению */
  isCompulsory: boolean;
  /** Название для периодов */
  periodLabel: string;
  /** Список несовместимых сервисов для текущего */
  incompatibleServices: Array<EServiceType>;
  /** Является тарифом по-умолчанию */
  isDefault: boolean;
  /** Доступна ли автопролонгация у тарифа */
  isAutoProlongAvailable: boolean;
  /** Количество доступных действий, сколько типов размещения можно купить */
  availableActionsCount: number;
  /** Описание тарифа */
  description: string;
  /** ID текущего сервиса */
  services: Array<EServiceType>;
  /** Доступен ли тариф в данном случае */
  isAvailable: boolean;
  /** Уникальный ключ тарифа */
  key: string;
}

export enum EUnavailableReason {
  /** Заблокировано администрацией */
  deniedBySanctions = 'deniedBySanctions',
  /** Нет фотографий */
  noPhotos = 'noPhotos',
  /** Доступно после окончания периода публикации Премиум */
  onlyAfterPremiumServiceExpiration = 'onlyAfterPremiumServiceExpiration',
  /** Не является участником акции */
  onlyInAction = 'onlyInAction',
  /** Не выполнены условия, необходимые для размещения Топ-объявлений */
  top3ServiceDenied = 'top3ServiceDenied',
}
